import { template } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
export interface Signature {
    Args: {
        class?: string;
    };
    Element: SVGElement;
}
const WrPipeIconComponent: TemplateOnlyComponent<Signature> = template(`
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M7.9993 1.28027C8.39694 1.28027 8.7193 1.60263 8.7193 2.00027L8.7193 14.0003C8.7193 14.3979 8.39694 14.7203 7.9993 14.7203C7.60165 14.7203 7.2793 14.3979 7.2793 14.0003L7.2793 2.00027C7.2793 1.60263 7.60165 1.28027 7.9993 1.28027Z'
      fill='currentColor'
    />
  </svg>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default WrPipeIconComponent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3NlbWVpYS9wYWNrYWdlcy9lbWJlci1hZGRvbnMvdjIvZW1iZXItd2lzZXIvc3JjL2NvbXBvbmVudHMvd3IvaWNvbnMvcGlwZS5ndHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBUZW1wbGF0ZU9ubHlDb21wb25lbnQgfSBmcm9tICdAZW1iZXIvY29tcG9uZW50L3RlbXBsYXRlLW9ubHknO1xuXG5leHBvcnQgaW50ZXJmYWNlIFNpZ25hdHVyZSB7XG4gIEFyZ3M6IHtcbiAgICBjbGFzcz86IHN0cmluZztcbiAgfTtcbiAgRWxlbWVudDogU1ZHRWxlbWVudDtcbn1cblxuY29uc3QgV3JQaXBlSWNvbkNvbXBvbmVudDogVGVtcGxhdGVPbmx5Q29tcG9uZW50PFNpZ25hdHVyZT4gPSA8dGVtcGxhdGU-XG4gIDxzdmdcbiAgICB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnXG4gICAgd2lkdGg9JzE2J1xuICAgIGhlaWdodD0nMTYnXG4gICAgdmlld0JveD0nMCAwIDE2IDE2J1xuICAgIGZpbGw9J25vbmUnXG4gICAgY2xhc3M9e3tAY2xhc3N9fVxuICAgIC4uLmF0dHJpYnV0ZXNcbiAgPlxuICAgIDxwYXRoXG4gICAgICBkPSdNNy45OTkzIDEuMjgwMjdDOC4zOTY5NCAxLjI4MDI3IDguNzE5MyAxLjYwMjYzIDguNzE5MyAyLjAwMDI3TDguNzE5MyAxNC4wMDAzQzguNzE5MyAxNC4zOTc5IDguMzk2OTQgMTQuNzIwMyA3Ljk5OTMgMTQuNzIwM0M3LjYwMTY1IDE0LjcyMDMgNy4yNzkzIDE0LjM5NzkgNy4yNzkzIDE0LjAwMDNMNy4yNzkzIDIuMDAwMjdDNy4yNzkzIDEuNjAyNjMgNy42MDE2NSAxLjI4MDI3IDcuOTk5MyAxLjI4MDI3WidcbiAgICAgIGZpbGw9J2N1cnJlbnRDb2xvcidcbiAgICAvPlxuICA8L3N2Zz5cbjwvdGVtcGxhdGU-O1xuXG5leHBvcnQgZGVmYXVsdCBXclBpcGVJY29uQ29tcG9uZW50O1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxjQUFjLHFCQUFxQixRQUFRLGlDQUFpQztBQUU1RSxpQkFBaUI7SUFDZjtRQUNFLFFBQVEsTUFBTTs7SUFFaEIsU0FBUzs7QUFHWCxNQUFNLHFCQUFxQixzQkFBc0IsYUFBYSxTQUFVLENBQUE7Ozs7Ozs7Ozs7Ozs7OztBQWV4RSxDQUFBLEVBQUE7SUFBQTtRQUFBLE9BQUEsS0FBQSxTQUFBLENBQUEsRUFBVztJQUFEO0FBQUE7QUFFVixlQUFlLG9CQUFvQiJ9